import React from "react";
import { useMediaQuery } from "react-responsive";

const SplashPage = ({ content }) => {
  const { imageDesktop, imageMobile } = content;
  const isMobile = useMediaQuery({ query: "(max-width: 576px)" });

  return (
    <div id="SplashPage">
      <div className="splashImage">
        {imageMobile && imageDesktop && (
          <img src={isMobile && imageMobile.url ? imageMobile.url : imageDesktop.url} alt="splashImage" />
        )}
      </div>
    </div>
  );
};

export default SplashPage;
